import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import GodownManagement from './components/GodownManagement';
import UnitConversionManagement from './components/UnitConversionManagement';
import { Warehouse, Combine } from 'lucide-react';

const InventoryPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">Inventory Management</h1>

      <Tabs defaultValue="godowns" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="godowns">
            <Warehouse className="mr-2 h-4 w-4" /> Godowns
          </TabsTrigger>
          <TabsTrigger value="conversions">
            <Combine className="mr-2 h-4 w-4" /> Unit Conversions
          </TabsTrigger>
        </TabsList>

        <TabsContent value="godowns">
          <Card>
            <CardHeader>
              <CardTitle>Manage Godowns</CardTitle>
              <CardDescription>View, add, edit, or delete storage locations.</CardDescription>
            </CardHeader>
            <CardContent>
              <GodownManagement />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="conversions">
          <Card>
            <CardHeader>
              <CardTitle>Manage Unit Conversions</CardTitle>
              <CardDescription>Define rules for converting between different units (e.g., Box to Pcs).</CardDescription>
            </CardHeader>
            <CardContent>
              <UnitConversionManagement />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default InventoryPage; 